import { useState, useRef, useCallback } from "react";

/**
 * 研讨厅相关状态 Hook
 */
const useDiscussState = () => {
  const [isDiscussOpen, setIsDiscussOpen] = useState(false);
  const [discussSessionId, setDiscussSessionId] = useState(null);
  const [discussPhase, setDiscussPhase] = useState('init');
  const [discussPanelists, setDiscussPanelists] = useState([]);
  const [discussMessages, setDiscussMessages] = useState([]);
  const [discussTopicSummary, setDiscussTopicSummary] = useState('');
  const [isDiscussWaiting, setIsDiscussWaiting] = useState(false);
  const [discussStatus, setDiscussStatus] = useState('idle'); // idle | preparing | active | completed

  const discussWsRef = useRef(null);

  // 重置研讨厅状态
  const resetDiscussState = useCallback(() => {
    setDiscussSessionId(null);
    setDiscussPhase('init');
    setDiscussPanelists([]);
    setDiscussMessages([]);
    setDiscussTopicSummary('');
    setIsDiscussWaiting(false);
    setDiscussStatus('idle');
    if (discussWsRef.current) {
      discussWsRef.current.close();
      discussWsRef.current = null;
    }
  }, []);

  return {
    isDiscussOpen,
    setIsDiscussOpen,
    discussSessionId,
    setDiscussSessionId,
    discussPhase,
    setDiscussPhase,
    discussPanelists,
    setDiscussPanelists,
    discussMessages,
    setDiscussMessages,
    discussTopicSummary,
    setDiscussTopicSummary,
    isDiscussWaiting,
    setIsDiscussWaiting,
    discussStatus,
    setDiscussStatus,
    discussWsRef,
    resetDiscussState,
  };
};

export default useDiscussState;
